module.exports = __webpack_public_path__ + "img/logo_login.892c14f7.png";